var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "forward")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "all-products---replace-product",
    transform: "translate(-654.000000, -335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(224.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(40.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward",
    transform: "translate(390.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3796F6",
    opacity: 0.05,
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#204569",
    strokeWidth: 1.5,
    points: "17 12 21 16 17 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 10,
    y2: 16,
    id: "Path-3",
    stroke: "#204569",
    strokeWidth: 1.5
  }))))))));
};

export default __webpack_public_path__ + "static/media/arrow-right.3169356a.svg";
export { SvgComponent as ReactComponent };